import { render, staticRenderFns } from "./storeOrderDetail.vue?vue&type=template&id=63d4752f&scoped=true"
import script from "./storeOrderDetail.vue?vue&type=script&lang=js"
export * from "./storeOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./storeOrderDetail.vue?vue&type=style&index=0&id=63d4752f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4752f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d4752f')) {
      api.createRecord('63d4752f', component.options)
    } else {
      api.reload('63d4752f', component.options)
    }
    module.hot.accept("./storeOrderDetail.vue?vue&type=template&id=63d4752f&scoped=true", function () {
      api.rerender('63d4752f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/storeOrderDetail.vue"
export default component.exports